import { useMemo } from "react";
import headerBackgroundUrl from "@/views/assets/images/dashboard/header-bg.png";

export interface DashboardHeaderProps {
    title?: string;
    time?: string;
}

/** 按旧 Vue dateFormat 输出固定宽度日期。 */
const formatDashboardDate = (date: Date) => {
    const pad = (value: number) => String(value).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

/** 看板页眉，复用旧 Vue 的横幅背景和三栏绝对定位。 */
export default function DashboardHeader({ title = "链云用户动态数据统计", time }: DashboardHeaderProps) {
    const today = useMemo(() => time || formatDashboardDate(new Date()), [time]);
    return (
        <header className="dashboard-header" style={{ backgroundImage: `url(${headerBackgroundUrl})` }}>
            <h1 className="dashboard-header__title">{title}</h1>
            <div className="dashboard-header__tabs" />
            <span className="dashboard-header__time">数据已更新至 {today}</span>
        </header>
    );
}
